import Secondary from "../components/Secondary";
import CreatePostForm from "../components/CreatePostForm";

const CreatePost = () => {
  return (
    <div className="relative bg-sky-blue-100 [backdrop-filter:blur(24px)] w-full overflow-hidden flex flex-col p-16 box-border items-center justify-start text-left text-21xl text-dark font-footnote">
      <div className="self-stretch flex flex-row items-start justify-between md:w-auto md:[align-self:unset] md:items-center md:justify-center sm:self-stretch sm:w-auto">
        <div className="flex-1 flex flex-col items-start justify-start gap-[32px] md:items-center md:justify-start md:pl-0 md:pr-0 md:box-border sm:flex-1 sm:pl-0 sm:box-border">
          <Secondary buttonText="Exit" secondaryPosition="unset" />
          <CreatePostForm />
        </div>
        <div className="self-stretch flex-1 flex flex-col p-16 items-center justify-end md:flex md:items-center md:justify-start sm:hidden sm:pl-4 sm:pr-4 sm:box-border">
          <img
            className="relative w-[261px] h-[261px] object-cover"
            alt=""
            src="/coming-soon-1@2x.png"
          />
          <div className="self-stretch relative">
            <b>Thank you</b>
            <span className="font-medium font-h2-accent">
              {" "}
              for empowering autism caregivers to provide easier, more enriching
              care to their patients.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreatePost;
